export const icons = {
	menigaLogo: {
		svgMarkup: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.7 44.09">
				<defs>
					<style>.cls-1{ fill:#ea6657; }</style>
				</defs>
				<g id="Layer_2" data-name="Layer 2">
					<g id="Layer_1-2" data-name="Layer 1">
						<path class="cls-1"
						      d="M47,43.06l-13.3-13.3a3.52,3.52,0,0,0-5,0L15.4,43.06a3.52,3.52,0,0,1-5,0L1,33.68a3.52,3.52,0,0,1,0-5L28.7,1a3.52,3.52,0,0,1,5,0L47,14.33a3.52,3.52,0,0,0,5,0L65.26,1a3.52,3.52,0,0,1,5,0l9.38,9.38a3.52,3.52,0,0,1,0,5L52,43.06A3.52,3.52,0,0,1,47,43.06Z" />
						<circle class="cls-1" cx="86.03" cy="32.71" r="10.66" />
					</g>
				</g>
			</svg>
		`,
	},
	kachingLogo: {
		svgMarkup:	`<svg
		version="1.1"
		id="svg2"
		xml:space="preserve"
		width="1163.0142"
		height="825.8476"
		viewBox="0 0 1163.0141 825.84758"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:svg="http://www.w3.org/2000/svg"><defs
			id="defs6"><clipPath
				clipPathUnits="userSpaceOnUse"
				id="clipPath22"><path
					d="M 0,2000 H 2000 V 0 H 0 Z"
					id="path20" /></clipPath></defs><g
			id="g8"
			transform="matrix(1.3333333,0,0,-1.3333333,-751.82611,1746.2572)"
			style="display:inline"><g
				id="g1150"
				style="fill:#ea6657;fill-opacity:1"><g
					id="g12"
					transform="translate(654.8521,915.2419)"
					style="fill:#ea6657;fill-opacity:1"><path
						d="m 0,0 h 27.652 v -9.217 l -43.87,-52.234 43.87,-52.233 v -9.218 H 0 l -40.285,48.136 h -24.068 v -48.136 H -90.982 V 0 h 26.629 v -48.137 h 24.068 l 15.363,18.264 z"
						style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
						id="path14" /></g><g
					id="g16"
					style="fill:#ea6657;fill-opacity:1"><g
						id="g18"
						clip-path="url(#clipPath22)"
						style="fill:#ea6657;fill-opacity:1"><g
							id="g24"
							transform="translate(721.4235,915.2427)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 h 72.206 c 7.055,0 13.058,-2.476 18.008,-7.426 4.952,-4.949 7.428,-10.899 7.428,-17.837 v -97.641 H 70.841 v 39.602 H 1.196 v -39.602 h -26.458 v 97.641 c 0,7.054 2.445,13.028 7.339,17.923 C -13.031,-2.448 -7.056,0 0,0 m 1.196,-56.673 h 69.645 v 30.044 H 1.196 Z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path26" /></g><g
							id="g28"
							transform="translate(961.0846,888.6132)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="M 0,0 H -96.102 V -69.644 H 0 v -26.629 h -97.298 c -7.057,0 -13.032,2.444 -17.924,7.339 -4.893,4.892 -7.339,10.865 -7.339,17.924 V 1.366 c 0,7.055 2.446,13.028 7.339,17.924 4.892,4.891 10.867,7.339 17.924,7.339 H 0 Z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path30" /></g><g
							id="g32"
							transform="translate(1078.0123,915.2419)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="M 0,0 H 26.458 V -122.902 H 0 v 48.136 h -72.547 v -48.136 H -99.005 V 0 h 26.458 V -48.137 H 0 Z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path34" /></g><path
							d="m 1124.271,915.243 h 26.627 V 792.341 h -26.627 z"
							style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
							id="path36" /><g
							id="g38"
							transform="translate(1267.3109,833.3071)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="M 0,0 V 81.936 H 26.799 V -40.967 H -0.512 L -69.645,41.308 V -40.967 H -96.101 V 81.936 h 27.311 z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path40" /></g><g
							id="g42"
							transform="translate(1436.1302,889.9791)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="M 0,0 V -11.607 H -26.799 V -1.366 H -96.443 V -71.01 h 69.644 v 18.434 h -26.629 v 26.629 H 0 v -46.43 c 0,-6.942 -2.474,-12.887 -7.426,-17.836 -4.949,-4.953 -10.952,-7.427 -18.009,-7.427 h -72.204 c -7.059,0 -13.032,2.446 -17.923,7.34 -4.895,4.892 -7.34,10.866 -7.34,17.923 V 0 c 0,7.055 2.445,13.029 7.34,17.923 4.891,4.892 10.864,7.339 17.923,7.339 h 72.204 c 7.057,0 13.06,-2.475 18.009,-7.423 C -2.474,12.887 0,6.94 0,0"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path44" /></g><g
							id="g46"
							transform="translate(935.6953,1302.0483)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 c 0,2.649 -0.361,5.196 -1.044,7.644 h 23.676 c 0.301,-2.086 0.502,-4.193 0.542,-6.36 0.02,-0.421 0.02,-0.843 0.02,-1.284 v -85.011 c 0,-6.4 -5.197,-11.597 -11.597,-11.597 -6.4,0 -11.597,5.197 -11.597,11.597 z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path48" /></g><g
							id="g50"
							transform="translate(1100.14,1309.6926)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 -19.041,-23.194 -104.654,-127.527 c -0.301,-0.361 -20.987,-24.979 -27.327,-33.306 -10.714,-14.105 -26.766,-21.589 -42.857,-21.589 -10.273,0 -20.565,3.03 -29.514,9.35 -13.784,9.711 -22.05,25.582 -22.11,42.476 v 0.02 146.126 c 0,2.588 0.2,5.156 0.561,7.644 h 23.696 c -0.682,-2.448 -1.043,-4.996 -1.043,-7.644 V -153.73 c 0,-4.695 1.163,-9.23 3.27,-13.282 2.107,-4.053 5.157,-7.585 8.989,-10.294 12.76,-8.988 30.577,-5.778 40.549,7.324 6.682,8.788 27.066,33.045 27.929,34.068 L -49.057,-23.194 -30.016,0 Z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path52" /></g><g
							id="g54"
							transform="translate(1204.8138,1309.6926)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 c -0.381,-0.521 -0.782,-1.043 -1.204,-1.545 l -17.736,-21.649 -1.685,-2.067 c -10.374,-12.78 -94.021,-114.786 -108.648,-132.843 -64.324,-79.434 -114.043,-140.749 -120.785,-147.791 -0.04,-0.061 -0.1,-0.101 -0.14,-0.161 -19.483,-19.643 -30.758,-23.836 -39.185,-25.341 -3.31,-0.582 -6.561,-0.882 -9.751,-0.882 -4.735,0 -9.31,0.661 -13.704,1.946 -21.99,6.5 -37.339,27.065 -37.339,49.999 0,6.4 5.197,11.597 11.597,11.597 6.42,0 11.617,-5.197 11.617,-11.597 0,-12.721 8.507,-24.137 20.706,-27.748 3.792,-1.124 8.226,-1.285 12.801,-0.462 2.689,0.482 9.811,1.746 26.705,18.74 4.394,4.654 32.965,39.646 64.687,78.731 0.441,1.244 1.063,2.448 1.946,3.531 l 151.202,184.348 10.694,13.042 c 3.11,3.832 5.859,7.223 8.227,10.152 z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path56" /></g><g
							id="g58"
							transform="translate(958.889,1286.4989)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="M 0,0 H -104.252 V 23.194 H -0.04 l 0.02,-6.361 z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path60" /></g><g
							id="g62"
							transform="translate(1204.8138,1309.6926)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="M 0,0 C -0.381,-0.521 -0.782,-1.043 -1.204,-1.545 L -18.94,-23.194 H -153.73 L -134.69,0 Z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path64" /></g><g
							id="g66"
							transform="translate(1100.14,977.4131)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 h -30.016 l -19.041,23.194 -27.541,33.569 c -3.496,4.261 -3.51,10.393 -0.037,14.671 4.629,5.698 13.317,5.718 17.971,0.045 l 39.623,-48.285 z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path68" /></g><g
							id="g70"
							transform="translate(1204.8138,977.4131)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 h -29.995 c -2.368,2.929 -5.117,6.32 -8.227,10.152 l -10.694,13.042 -80.188,97.77 c -3.495,4.263 -3.507,10.397 -0.028,14.674 l 0.093,0.115 c 4.632,5.696 13.322,5.714 17.971,0.03 C -81.325,99.411 -28.714,35.226 -20.625,25.26 L -18.94,23.194 -1.204,1.545 C -0.782,1.043 -0.381,0.521 0,0"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path72" /></g><g
							id="g74"
							transform="translate(1204.8138,977.4131)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="M 0,0 C -0.381,0.521 -0.782,1.043 -1.204,1.545 L -18.94,23.194 H -153.73 L -134.69,0 Z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:evenodd;stroke:none"
								id="path76" /></g><g
							id="g78"
							transform="translate(645.8886,757.4752)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 h -66.141 c -0.533,0 -0.799,-0.268 -0.799,-0.8 v -50.49 c 0,-0.533 0.266,-0.799 0.799,-0.799 H 0 v -15.079 h -66.141 c -4.418,0 -8.167,1.542 -11.252,4.626 -3.084,3.085 -4.626,6.834 -4.626,11.252 V -0.8 c 0,4.416 1.542,8.168 4.626,11.252 3.085,3.084 6.834,4.626 11.252,4.626 H 0 Z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:nonzero;stroke:none"
								id="path80" /></g><g
							id="g82"
							transform="translate(691.3498,733.0298)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 h 51.976 v 23.646 c 0,0.531 -0.268,0.799 -0.801,0.799 H 0.801 C 0.267,24.445 0,24.177 0,23.646 Z m 0.801,39.524 h 50.374 c 4.417,0 8.187,-1.543 11.31,-4.627 3.122,-3.084 4.684,-6.836 4.684,-11.251 V -42.722 H 51.976 v 27.644 H 0 v -27.644 h -15.078 v 66.368 c 0,4.415 1.542,8.167 4.627,11.251 3.083,3.084 6.834,4.627 11.252,4.627"
								style="fill:#ea6657;fill-opacity:1;fill-rule:nonzero;stroke:none"
								id="path84" /></g><g
							id="g86"
							transform="translate(871.4924,756.6754)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="M 0,0 V -6.283 H -15.193 V 0 c 0,0.532 -0.227,0.8 -0.685,0.8 h -50.49 c -0.534,0 -0.799,-0.268 -0.799,-0.8 v -16.906 c 0,-0.534 0.265,-0.8 0.799,-0.8 h 50.49 c 4.341,0 8.071,-1.542 11.195,-4.626 C -1.562,-25.416 0,-29.168 0,-33.584 V -50.49 c 0,-4.418 -1.562,-8.167 -4.683,-11.252 -3.124,-3.084 -6.854,-4.626 -11.195,-4.626 h -50.49 c -4.417,0 -8.167,1.542 -11.251,4.626 -3.085,3.085 -4.627,6.834 -4.627,11.252 v 6.283 h 15.079 v -6.283 c 0,-0.533 0.265,-0.8 0.799,-0.8 h 50.49 c 0.458,0 0.685,0.267 0.685,0.8 v 16.906 c 0,0.532 -0.227,0.8 -0.685,0.8 h -50.49 c -4.417,0 -8.167,1.542 -11.251,4.626 -3.085,3.084 -4.627,6.835 -4.627,11.252 V 0 c 0,4.416 1.542,8.167 4.627,11.252 3.084,3.084 6.834,4.626 11.251,4.626 h 50.49 c 4.341,0 8.071,-1.542 11.195,-4.626 C -1.562,8.167 0,4.416 0,0"
								style="fill:#ea6657;fill-opacity:1;fill-rule:nonzero;stroke:none"
								id="path88" /></g><g
							id="g90"
							transform="translate(971.1009,772.5536)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="M 0,0 H 15.078 V -82.246 H 0 v 33.583 H -53.917 V -82.246 H -68.996 V 0 h 15.079 V -33.584 H 0 Z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:nonzero;stroke:none"
								id="path92" /></g><g
							id="g94"
							transform="translate(1084.8741,706.1856)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 v 17.705 c 0,0.458 -0.268,0.686 -0.801,0.686 h -50.374 c -0.534,0 -0.801,-0.228 -0.801,-0.686 V 0 c 0,-0.534 0.267,-0.8 0.801,-0.8 H -0.801 C -0.268,-0.8 0,-0.534 0,0 m -3.999,51.29 h -47.176 c -0.534,0 -0.801,-0.269 -0.801,-0.8 V 34.383 c 0,-0.533 0.267,-0.799 0.801,-0.799 h 47.176 c 0.458,0 0.685,0.266 0.685,0.799 V 50.49 c 0,0.531 -0.227,0.8 -0.685,0.8 m 15.878,-0.8 V 34.383 c 0,-2.284 -0.381,-4.226 -1.142,-5.825 2.97,-3.124 4.456,-6.74 4.456,-10.853 L 15.193,0 c 0,-4.418 -1.563,-8.168 -4.684,-11.252 -3.124,-3.084 -6.893,-4.626 -11.31,-4.626 h -66.253 v 82.246 h 63.055 c 4.341,0 8.071,-1.543 11.194,-4.626 3.122,-3.085 4.684,-6.836 4.684,-11.252"
								style="fill:#ea6657;fill-opacity:1;fill-rule:nonzero;stroke:none"
								id="path96" /></g><g
							id="g98"
							transform="translate(1146.1,733.0298)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 h 51.976 v 23.646 c 0,0.531 -0.268,0.799 -0.801,0.799 H 0.8 C 0.267,24.445 0,24.177 0,23.646 Z m 0.8,39.524 h 50.375 c 4.417,0 8.187,-1.543 11.31,-4.627 3.122,-3.084 4.683,-6.836 4.683,-11.251 V -42.722 H 51.976 v 27.644 H 0 v -27.644 h -15.078 v 66.368 c 0,4.415 1.542,8.167 4.627,11.251 3.083,3.084 6.833,4.627 11.251,4.627"
								style="fill:#ea6657;fill-opacity:1;fill-rule:nonzero;stroke:none"
								id="path100" /></g><g
							id="g102"
							transform="translate(1326.5842,757.4752)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 h -66.139 c -0.534,0 -0.799,-0.268 -0.799,-0.8 v -50.49 c 0,-0.533 0.265,-0.799 0.799,-0.799 H 0 v -15.079 h -66.139 c -4.418,0 -8.168,1.542 -11.252,4.626 -3.084,3.085 -4.626,6.834 -4.626,11.252 V -0.8 c 0,4.416 1.542,8.168 4.626,11.252 3.084,3.084 6.834,4.626 11.252,4.626 H 0 Z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:nonzero;stroke:none"
								id="path104" /></g><g
							id="g106"
							transform="translate(1419.5677,772.5536)"
							style="fill:#ea6657;fill-opacity:1"><path
								d="m 0,0 h 16.562 v -3.998 l -31.07,-37.125 31.07,-37.125 v -3.998 H 0 l -28.101,33.583 h -19.42 V -82.246 H -62.714 V 0 h 15.193 v -33.584 h 19.42 z"
								style="fill:#ea6657;fill-opacity:1;fill-rule:nonzero;stroke:none"
								id="path108" /></g></g></g></g></g></svg> 
								`
	},
}
